"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverStatus = void 0;
var DriverStatus;
(function (DriverStatus) {
    DriverStatus[DriverStatus["Hired"] = 0] = "Hired";
    DriverStatus[DriverStatus["Active"] = 1] = "Active";
    DriverStatus[DriverStatus["Declined"] = 2] = "Declined";
    DriverStatus[DriverStatus["Lead"] = 3] = "Lead";
})(DriverStatus || (exports.DriverStatus = DriverStatus = {}));
//# sourceMappingURL=DriverStatus.js.map